import React from 'react';
import { Route } from 'react-router-dom';
import Login from 'pages/login/index';
import SignUp from 'pages/signUp/index';
import Welcome from 'pages/welcome/index';
import ChooseRole from 'pages/chooseRole/index';
import RestorePassword from 'pages/restorePassoword';
import SendEmail from 'pages/restorePassoword/sendEmail';
import SuccessfulRegistration from 'pages/successfulRegistration';

const getUnprotectedRoutes = (): JSX.Element[] => [
  <Route key="choose-role" path="/choose-role">
    <ChooseRole />
  </Route>,
  <Route key="login" path="/login">
    <Login />
  </Route>,
  <Route key="sign-up-referral" path="/sign-up/:referralId/">
    <SignUp />
  </Route>,
  <Route key="sign-up" path="/sign-up/">
    <SignUp />
  </Route>,
  <Route key="welcome" path="/welcome">
    <Welcome />
  </Route>,
  <Route key="send-email" path="/send-email">
    <SendEmail />
  </Route>,
  <Route key="change-password" path="/change-password/:code/:email">
    <RestorePassword />
  </Route>,
  <Route key="registration-success" path="/registration-success">
    <SuccessfulRegistration />
  </Route>,
];

export default getUnprotectedRoutes;
